import React from 'react';
import { Observe } from 'rewire-core';
import { WithStyle, ToggleMenu, IToggleMenuItem } from 'rewire-ui';
import { PopoverOrigin } from '@material-ui/core/Popover';
import { Theme } from '@material-ui/core/styles';
import SettingsIcon from '@material-ui/icons/Settings';
import PostedScheduleReportOptionsModel from './PostedScheduleReportOptionsModel';
import ReportOptionsModel from './ReportOptionsModel';
import reportModel from './ReportModel';
import { withStyles } from '../utility/styles';

// add the report name / model for any reports that have options
export const reportOptionsModelMap = {
  'Job Schedule': new PostedScheduleReportOptionsModel('NewJob'),
  'Posted Job Schedule': new PostedScheduleReportOptionsModel(),
  'Posted Employee Schedule': new PostedScheduleReportOptionsModel('Employee'),
  'Mixed Posted Schedule': new PostedScheduleReportOptionsModel('Mixed'),
  Default: new ReportOptionsModel(),
};

const styles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    flex: '0 0 auto',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    marginBottom: '7px',
  },
  menuButton: {
    minWidth: '0px',
    minHeight: '0px',
    padding: '0px',
    marginLeft: '15px',
  },
});

interface IReportOptionsProps {
  classes?: any;
}

type ReportOptionsProps = WithStyle<ReturnType<typeof styles>, IReportOptionsProps>;

class ReportOptions extends React.PureComponent<ReportOptionsProps> {
  items: IToggleMenuItem[];

  constructor(props: ReportOptionsProps) {
    super(props);
  }

  render() {
    return (
      <Observe
        render={() => {
          const { classes } = this.props;
          const model = reportModel.reportOptionsModel;
          const buttonContent = <SettingsIcon />;
          const buttonProps = { disableRipple: true, disabled: !model?.items?.length };
          const anchorOrigin: PopoverOrigin = { vertical: 'bottom', horizontal: 'right' };
          const transformOrigin: PopoverOrigin = { vertical: 'top', horizontal: 'right' };
          const items = model?.items ?? [];

          if (items.length === 0) return null;

          return (
            <div className={classes.root}>
              <ToggleMenu
                menuId="report-options-toggle-menu"
                classes={{ menuButton: classes.menuButton }}
                buttonContent={buttonContent}
                buttonProps={buttonProps}
                getContentAnchorEl={null}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
                title="Report Display Options"
                tooltip="Report Display Options"
                items={items}
              />
            </div>
          );
        }}
      />
    );
  }
}

export default withStyles<IReportOptionsProps>(styles, ReportOptions);
